import type { ReactNode } from 'react';
import { Link } from 'react-router';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/utils/cn';

export const DashboardSectionCard = ({
  title,
  icon,
  to,
  viewAllLabel,
  loading,
  empty,
  hasItems,
  compact = false,
  children,
}: {
  title: string;
  icon: ReactNode;
  to?: string;
  viewAllLabel?: string;
  loading: boolean;
  empty: string;
  hasItems: boolean;
  compact?: boolean;
  children: ReactNode;
}) => (
  <Card className="flex h-full flex-col overflow-hidden [&>div:last-child]:min-h-0 [&>div:last-child]:flex-1">
    <CardHeader
      className={cn(
        'flex-row items-center justify-between gap-3',
        compact ? 'p-3 pb-2' : undefined,
      )}
    >
      <CardTitle className="flex items-center gap-2 text-card-title">
        {icon}
        {title}
      </CardTitle>
      {!compact && to && viewAllLabel ? (
        <Button variant="ghost" size="sm" asChild>
          <Link to={to}>{viewAllLabel}</Link>
        </Button>
      ) : null}
    </CardHeader>
    <CardContent
      className={cn('flex-1 overflow-hidden', compact ? 'p-3 pt-0' : 'pt-0')}
    >
      {loading ? (
        <p className="text-body-sm text-fg-muted">…</p>
      ) : !hasItems ? (
        <p className="text-body-sm text-fg-muted">{empty}</p>
      ) : (
        children
      )}
    </CardContent>
  </Card>
);
